import { render, staticRenderFns } from "./PFSettlementListFront.vue?vue&type=template&id=2b9b4264"
import script from "./PFSettlementListFront.vue?vue&type=script&lang=js"
export * from "./PFSettlementListFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports